import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Alert from 'react-s-alert';

import Galleries from 'api/resources/galleries';
import { processErrorByAlert } from 'utils/getErrors';

import PrimaryButton from 'styled/Buttons/PrimaryButton';
import SecondaryButton from 'styled/Buttons/SecondaryButton';
import Footer from 'components/ConfirmModal/Footer';
import Text from 'components/ConfirmModal/Text';
import Content from 'components/ConfirmModal/Content';
import Title from 'components/ConfirmModal/Title';
import ConfirmModal from 'components/ConfirmModal';

export class DeleteGallery extends React.Component {
  state = {
    isOpen: false,
  }

  handleDeleteClick = () => {
    this.setState({ isOpen: true });
  }

  handleCloseModalClick = () => {
    this.setState({ isOpen: false });
  }

  handleDelete = async () => {
    this.setState({ loading: true });

    try {
      await Galleries.delete({ galleryId: this.props.match.params.galleryId });

      Alert.success('Галерея успешно удалена');
      this.props.history.push('/galleries');
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <React.Fragment>
        <SecondaryButton
          type="button"
          style={{ padding: '12px 0', width: '100%' }}
          onClick={this.handleDeleteClick}
        >
          Удалить
        </SecondaryButton>

        <ConfirmModal
          onClose={this.handleCloseModalClick}
          isOpen={this.state.isOpen}
        >
          <Content>
            <Title>Удаление</Title>

            <Text>Вы точно хотите удалить галерею?</Text>
          </Content>

          <Footer>
            <PrimaryButton
              type="button"
              onClick={this.handleDelete}
              autoFocus
              style={{ marginRight: '10px' }}
              disabled={this.state.loading}
            >
              Удалить
            </PrimaryButton>

            <SecondaryButton
              type="button"
              onClick={this.handleCloseModalClick}
              disabled={this.state.loading}
            >
              Отмена
            </SecondaryButton>
          </Footer>
        </ConfirmModal>
      </React.Fragment>
    );
  }
}

DeleteGallery.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      galleryId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({ push: PropTypes.func }),
};

DeleteGallery.defaultProps = {
  history: { push: () => {} },
};

export default withRouter(DeleteGallery);
